/**
 * MultiBuy Builder - search.js
 * Pure, debounced client-side search over an already-fetched product array.
 * Matches on title, vendor, tags, product_type (per spec). No DOM access.
 * Attaches to window.MB.search
 */
(function (window) {
  'use strict';

  var MB = (window.MB = window.MB || {});

  function normalize(str) {
    return (str || '').toString().toLowerCase().trim();
  }

  function matches(product, query) {
    if (!query) return true;
    var q = normalize(query);
    if (normalize(product.title).indexOf(q) !== -1) return true;
    if (normalize(product.vendor).indexOf(q) !== -1) return true;
    if (normalize(product.product_type).indexOf(q) !== -1) return true;
    if ((product.tags || []).some(function (t) { return normalize(t).indexOf(q) !== -1; })) return true;
    return false;
  }

  function searchProducts(products, query) {
    if (!query) return products.slice();
    return products.filter(function (p) {
      return matches(p, query);
    });
  }

  /**
   * Creates a debounced search controller.
   * onResult(filteredProducts, query) is called after each debounced run.
   */
  function createSearchController(getProducts, onResult, wait) {
    var utils = MB.utils;
    var currentQuery = '';

    var run = utils.debounce(function () {
      onResult(searchProducts(getProducts(), currentQuery), currentQuery);
    }, wait || 250);

    return {
      setQuery: function (query) {
        currentQuery = query;
        run();
      },
      getQuery: function () {
        return currentQuery;
      }
    };
  }

  MB.search = {
    searchProducts: searchProducts,
    createSearchController: createSearchController
  };
})(window);
